import React from 'react'

import { IconComponent } from '@octane/spark'

import { NavbarNavLabel } from '../../NavbarItem/NavbarItem.styled'
import {
    NavbarDropdownIcon,
    NavbarDropdownItem,
} from '../NavbarDropdown.styled'

const ICON_SIZE = 21

export interface NavbarDropdownButtonProps {
    id: string
    text: string
    icon: IconComponent
    isActive?: boolean
    isNavbarWhite?: boolean
    onClick?: () => void
}

export default function NavbarDropdownButton({
    id,
    text,
    icon: DropdownIcon,
    isActive,
    isNavbarWhite,
    onClick,
}: Readonly<NavbarDropdownButtonProps>): JSX.Element {
    return (
        <NavbarDropdownItem
            id={id}
            as="button"
            type="button"
            onClick={onClick}
            isActive={isActive}
            isNavbarWhite={isNavbarWhite}
        >
            <DropdownIcon width={ICON_SIZE} height={ICON_SIZE} />

            <span>
                <NavbarNavLabel>{text}</NavbarNavLabel>
                <NavbarDropdownIcon width={9} height={9} />
            </span>
        </NavbarDropdownItem>
    )
}
